import React, { useState, useEffect } from "react";
import { CustomerViewDetailsViewDocumentInfoProps } from "./customer-view-details-view-document-info.props";
import "./customer-view-details-view-document-info.scss";
import UploadFileDocument from "./upload-file-document";
import ListAttachMents from "./list-documents";
// import { getDocuments } from "../../../../../../api/lead";
import { AlertComponent, ConfirmationPopup } from "../../../../../../common/components";
import DeleteIcon from "../../../../../../assets/icons/archive-icon.svg";
import DataTable from "../../../../../campaign/campiagn-view/campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/task-table/task-table";
import { IconButton, Tooltip } from "@mui/material";
import { documentColumns } from "./customer-view-details-view-document-info.constant";
import ConfirmInfo from "../../../../../../assets/icons/confirm-info.svg";
import EditIcon from "../../../../../../assets/icons/edit.svg";
import { getCampaigns } from "../../../../../../api/campaign";
import { deleteDocument, getCustomerDetails, getCustomers } from "../../../../../../api/customer";
interface DocumentItem {
  id: number;
  documentName: string;
  category: string;
  created_at: string;
}


const CustomerViewDetailsViewDocumentInfo: React.FC<
  CustomerViewDetailsViewDocumentInfoProps
> = ({ setLoading, leadId, disableEdit, permissions }) => {
  const [documentsList, setDocumentsList] = useState<DocumentItem[]>([]);
  const [editDataDocument, setEditDataDocument] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState<any>(null);
    const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const handleeditDataDocument = (document: any) => {
    setEditDataDocument(document);
    setIsUploadOpen(true);
  };
  const handleDeleteDocument = (document: any) => {
    setDocumentToDelete(document);
    setIsArchivePopupOpen(true);
  };
  const confirmDeleteEmail = async () => {
    if (!documentToDelete) return;
    setLoading(true);
    try {
      await deleteDocument(leadId,documentToDelete.id);
      setAlertMessage("Document archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchDocuments();
    } catch (error) {
      setAlertMessage("Failed to archive Document.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpen(false);
      setDocumentToDelete(null);
      setLoading(false);
    }
  };

  const fetchDocuments = async () => {
    setLoading(true);
    try {
       const response = await  getCustomerDetails(leadId);
       setDocumentsList(response?.data?.data?.documents);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message || "Failed to get customer documents."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [leadId]);

  return (
    <>
      <div className="customer-list-view-details-view-box-document-info">
        <div className="customer-list-view-details-view-box-document-info-header">
          <div className="customer-list-view-details-view-box-document-info-header-text">
            Documents
          </div>
          <div>
            <button
              className="customer-list-view-details-view-box-document-info-header-button"
              disabled={!permissions?.canWrite}
              onClick={() =>{

               setIsUploadOpen(true)
                setEditDataDocument(null);}}
            // disabled={disableEdit}
            >
              Add New
            </button>
          </div>
        </div>
        <div>
          {isUploadOpen && (
            <UploadFileDocument
              open={isUploadOpen}
              onClose={() => {
                setIsUploadOpen(false)
                setEditDataDocument(null);
              }} // close popup
              onSave={() =>{
                fetchDocuments();
                 setIsUploadOpen(false)
                 setEditDataDocument(null);
                 
              }
                }
              leadId={leadId}
              title={editDataDocument ? "Edit Document" : "Create Document"}
              initialDocument={editDataDocument}
              //fetchDocuments={fetchDocuments}
            />
          )}

        </div>
        <div className="customer-list-view-details-view-box-document-info-content">
          {documentsList && documentsList?.length > 0 ? (
            <DataTable
              columns={documentColumns}
              data={documentsList}
              rowActions={(document) => (
                <div style={{ display: "flex" }}>
                   <Tooltip className="tooltip" title="Edit">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleeditDataDocument(document);
                    }}
                    className="icon-button"
                    disabled={!permissions?.canWrite}
                  >
                    <img src={EditIcon} alt="edit" className="img-icon" />
                  </IconButton>
                  </Tooltip>
                   <Tooltip className="tooltip" title="Archive">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteDocument(document);
                    }}
                    className="icon-button"
                  >
                    <img src={DeleteIcon} alt="archive" className="img-icon" />
                  </IconButton>
                  </Tooltip>
                </div>
              )}
            />
          ) : (
            <div className="customer-list-view-details-view-box-document-info-no-data">
              No Documents
            </div>
          )}
        </div>
      </div>
      <div className="mark-completed">
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setDocumentToDelete(null);
          }}
          onOkay={confirmDeleteEmail}
          title="Archive Document"
          note={
            documentToDelete
              ? `Are you sure you want to archive the Document?`
              : "Are you sure you want to archive this Document"
          }
          buttonText="Archive"
        />
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </>
  );

};

export default CustomerViewDetailsViewDocumentInfo;
